const template = () => {
    return `<button class="toggle js-truncate-toggle">&middot;&middot;&middot;</button>`;
};

export const createToggle = () => {
    let element = document.createElement("template");
    element.innerHTML = template();
    return element.content.firstChild;
};

export default template;